import type { RBOAlertKind } from '@openx/types/deal';
import {
  createContext,
  type Dispatch,
  type PropsWithChildren,
  type SetStateAction,
  useContext,
  useMemo,
  useState,
} from 'react';

export type RboDisplayedAlertKind = RBOAlertKind | null;

type RboDisplayedAlertContextValue = {
  displayedKind: RboDisplayedAlertKind;
  setDisplayedKind: Dispatch<SetStateAction<RboDisplayedAlertKind>>;
};

const RboDisplayedAlertContext = createContext<RboDisplayedAlertContextValue | null>(null);

export const RboDisplayedAlertProvider = ({ children }: PropsWithChildren) => {
  const [displayedKind, setDisplayedKind] = useState<RboDisplayedAlertKind>(null);
  const value = useMemo(() => ({ displayedKind, setDisplayedKind }), [displayedKind]);

  return <RboDisplayedAlertContext.Provider value={value}>{children}</RboDisplayedAlertContext.Provider>;
};

export const useRboDisplayedAlert = (): RboDisplayedAlertContextValue => {
  const context = useContext(RboDisplayedAlertContext);

  if (!context) {
    throw new Error('"useRboDisplayedAlert" must be used within the "RboDisplayedAlertContext"');
  }

  return context;
};
